import Mask from "./Mask";
import SpinLoading from "./SpinLoading";


const style: React.CSSProperties = {
  'display': 'flex',
  'justifyContent': 'center',
  'alignItems': 'center',
  'background': 'rgba(0, 0, 0, 0.2)',
}

const Loading: React.FC<{ loading: boolean }> = ({ loading }) => {
  return <Mask visible={loading} style={style}>
    <SpinLoading />
  </Mask>
}

export default Loading;
